import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAkLpNCJ_KSytT-HIi6fBwmBkLnUJvs8LU",
  authDomain: "chaitanya-academy-16c76.firebaseapp.com",
  projectId: "chaitanya-academy-16c76",
  storageBucket: "chaitanya-academy-16c76.firebasestorage.app",
  messagingSenderId: "678803145231",
  appId: "1:678803145231:web:224c5c09192d597d05597a",
  measurementId: "G-Q1V9LXFXKE"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);